// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticlesSidebar_title__2bER-","cont":"ArticlesSidebar_cont__PRTKe","nav":"ArticlesSidebar_nav__3m7B9","current":"ArticlesSidebar_current__2C2qS"};